<template>
  <stripe-checkout
    ref="checkoutRef"
    :pk="publishableKey"
    :items="items"
    :session-id="sessionId"
    :successUrl="successUrl"
    :cancelUrl="cancelUrl"
  >
    <template slot="checkout-button">
      <button @click="checkout">Shut up and take my money!</button>
    </template>
  </stripe-checkout>
</template>

<!--When using sessions, you'll only need the session-id. 
This is because the session is the representation of all of the 
information about the payment to done.-->


<script>
import { StripeCheckout } from 'vue-stripe-checkout';

export default {
  components: {
    StripeCheckout
  },
  data: () => ({
    loading: false,
    publishableKey:'pk_test_51He2KMEEnzIOZd2sakAuJIOviYhEf63hJtrX9Vpmt1EmfUIYaH4aBgST0I4RlAvnuK6RzBWLJt9OpsNKiv64NiCm00ATHCBeSD', //! insert publish_key FROM clients data // process.env.PUBLISHABLE_KEY //
    items: [
      {
        sku: 'sku_FdQKocNoVzznpJ', 
        quantity: 1
      }
    ],
    successUrl: '/dashboard',
    cancelUrl: '/admin-panel',
  }),
  methods: {
    checkout () {
      this.$refs.checkoutRef.redirectToCheckout();
    }
  }
}
</script>

<style scoped>

</style>